import { Table } from 'antd'
import React from 'react'

export default function ServicePreviewTable({ data, blank }) {
  return (
      <Table dataSource={data} rowKey={(r) => r.id} scroll={{ x: "max-content" }}>
        <Table.Column title="Service ID" key="id" dataIndex="id" />
        <Table.Column title="Account Number" key="account_number" dataIndex="account_number" />
        <Table.Column title="Vendor" key="vendor" dataIndex="vendor" />
        <Table.Column title="Facility" key="facility" dataIndex="facility" />
        <Table.Column title="Utility Service" key="utility_service" dataIndex="utility_service" />
        <Table.Column title="Meter Number" key="meter_number" dataIndex={!blank ? "meter_number" : ""} />
        <Table.Column title="ID Number" key="id_number" dataIndex={!blank ? "id_number" : ""} />
        <Table.Column title="Service Name 1" key="service_name_1" dataIndex={!blank ? "service_name_1" : ""} />
        <Table.Column title="Service Name 2" key="service_name_2" dataIndex={!blank ? "service_name_2" : ""} />
        <Table.Column title="Tax Code" key="tax_code" dataIndex={!blank ? "tax_code" : ""} />
        <Table.Column title="Rate Schedule" key="rate_schedule" dataIndex={!blank ? "rate_schedule" : ""} />
        <Table.Column title="Contract Demand Capacity" key="contract_demand_capacity" dataIndex={!blank ? "contract_demand_capacity" : ""} />
        <Table.Column title="Supply" key="supply" dataIndex={!blank ? "supply" : ""} />
        <Table.Column title="Meter Multiplier" key="meter_multiplier" dataIndex={!blank ? "meter_multiplier" : ""} />
        <Table.Column title="Emissions Factor" key="emissions_factor" dataIndex={!blank ? "emissions_factor" : ""} />
        <Table.Column title="Rank" key="rank" dataIndex={!blank ? "rank" : ""} />
        <Table.Column title="Unit of Measure" key="unit_of_measure" dataIndex={!blank ? "unit_of_measure" : ""} />
        <Table.Column title="Ledger Account" key="ledger_account" dataIndex={!blank ? "ledger_account" : ""} />
        <Table.Column title="Billable Ledgers" key="billable_ledgers" dataIndex={!blank ? "billable_ledgers" : ""} />
        <Table.Column title="Notes" key="notes" dataIndex={!blank ? "notes" : ""} />
        <Table.Column title="Active" key="active" dataIndex={!blank ? "active" : ""} />
      </Table>
  )
}
